<template>
  <div class="zghBox">
    <div class="classify">
      <div class="left">
        <span class="status">状态：</span>
        <span
          @click="setStatusAct(1)"
          :class="type === 1 ? 'act' : 'statusList'"
          >全部</span
        >
        <span
          @click="setStatusAct(2)"
          :class="type === 2 ? 'act' : 'statusList'"
          >已报名</span
        >
        <span
          @click="setStatusAct(3)"
          :class="type === 3 ? 'act' : 'statusList'"
          >已取消</span
        >
        <span
          @click="setStatusAct(4)"
          :class="type === 4 ? 'act' : 'statusList'"
          >已结束</span
        >
      </div>
      <!-- <div class="right">
        <span class="time">时间：</span>
        <DatePicker
          :value="TimeValue"
          format="yyyy/MM/dd"
          @on-change="handleChange"
          type="daterange"
          placement="bottom-end"
          placeholder="Select date"
          style="width: 220px"
        ></DatePicker>
        <Input
          v-model="search"
          placeholder="请输入标题进行搜索"
          class="searchinput"
        >
          <Icon @click="handleClick" type="ios-search" slot="suffix" />
        </Input>
      </div> -->
    </div>

    <div class="list">
      <div class="box" v-for="item in list" :key="item.id">
        <img class="img" v-lazy="$global.imgUrl + item.cover" alt="" />
        <div class="right">
          <div style="flex: 1">
            <p
              style="
                width: 550px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
            >
              <span :class="item.status | colored(item.endTime)">{{
                item.status | type(item.endTime)
              }}</span>
              <span
                :class="item.status | colored(item.endTime)"
                style="margin-right: 20px"
                >|</span
              >
              <span class="title">{{ item.title }}</span>
            </p>
            <div style="margin: 20px 0">
              <Icon
                type="ios-time-outline"
                size="24"
                color="#3C4F83"
                style="vertical-align: middle"
              />
              <span style="color: #3c4f83; font-weight: bold"> 时间：</span>
              <span style="color: #000">{{ item.beginTime }}</span>
            </div>
            <div class="place">
              {{ item.collectionNum === 1 ? "线下会议" : "线上会议" }}
            </div>
          </div>
          <div>
            <span class="checkBtn" @click="checkTickets(item.id)"
              >查看门票</span
            >
            <span class="checkBtn" @click="toDetails(item.id)">查看会议</span>
          </div>
        </div>
      </div>
    </div>
    <Paging
      :total="total"
      :curPage="page"
      :limit="10"
      :showPage="5"
      @changePager="handlePager"
    ></Paging>
    <Modal
      v-model="ticketsModal"
      width="1000"
      mask-closable
      footer-hide
      @on-visible-change="modalChange"
    >
      <div class="tickets-modal">
        <h3 class="modal-title">查看门票</h3>
        <div class="tickets-item">
          <TicketsItem
            :meetingId="meetingId"
            :tickets="tickets"
            :item="item"
            v-for="item in ticketsList"
            :key="item.id"
          />
          <Scroll
            class="tickets-scroll"
            :scrollFlag="scrollFlag"
            :isEnd="isEnd"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Paging from "@/components/paging/index.vue";
import TicketsItem from "./ticketsItem.vue";
import Scroll from "@/components/paging/scroll";

export default {
  name: "tickets",
  components: {
    Paging,
    TicketsItem,
    Scroll,
  },
  data() {
    return {
      type: 1,
      // TimeValue: [null, null],
      // search: null,
      page: 1,
      total: 0,
      list: [],
      meetingId: "",
      ticketsPage: 1,
      tickets: {},
      ticketsList: [],
      ticketsModal: false,
      scrollFlag: false,
      isEnd: false,
    };
  },
  created() {
    this.getList();
  },
  filters: {
    type: function (type, time) {
      if (type === 1) {
        let nowTime = new Date().valueOf();
        let endTime = new Date(time).valueOf();
        if (nowTime >= endTime) {
          return "已结束";
        } else {
          return "已报名";
        }
      } else if (type === 2) {
        return "已取消";
      }
    },
    colored: function (type, time) {
      if (type === 1) {
        let nowTime = new Date().valueOf();
        let endTime = new Date(time).valueOf();
        if (nowTime >= endTime) {
          return "red";
        } else {
          return "blur";
        }
      } else if (type === 2) {
        return "yellow";
      }
    },
  },
  methods: {
    modalChange(query) {
      let dom = document.getElementsByClassName("tickets-item")[0];
      if (query) {
        dom.addEventListener("scroll", this.ticketsHandlePager);
      } else {
        dom.removeEventListener("scroll", this.ticketsHandlePager);
        this.meetingId = "";
        this.tickets = {};
        this.ticketsList = [];
      }
    },
    ticketsHandlePager() {
      let dom = document.getElementsByClassName("tickets-item")[0];
      let containerHeight = dom.clientHeight + dom.scrollTop;
      let scrollHeight = dom.scrollHeight;
      if (containerHeight + 1 >= scrollHeight && !this.scrollFlag && !this.isEnd) {
        let obj = {
          meetingId: this.meetingId,
          type: this.type,
          pageNo: ++this.ticketsPage,
          pageSize: 5,
        };
        this.getTicketList(obj);
      }
    },
    async checkTickets(id) {
      this.meetingId = id;
      let obj = {
        meetingId: id,
        type: this.type,
        pageNo: 1,
        pageSize: 5,
      };
      this.getTicketList(obj);
      this.ticketsModal = true;
      this.ticketsPage = 1;
    },
    async getTicketList(param) {
      this.scrollFlag = true;
      this.isEnd = false;
      const res = await this.$apis.userServe.myTicketList(param);
      if (res.resultCode === "200") {
        this.tickets = res.data;
        this.ticketsList.push(...res.data.pageInfo.list);
        this.scrollFlag = false;
        this.isEnd = this.ticketsPage >= res.data.pageInfo.total / 5;
      }
    },
    toDetails(id) {
      let routeUrl = this.$router.resolve({
        path: "/meetingDetails",
        query: {
          type: 8,
          id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    setStatusAct(type) {
      this.type = type;
      this.page = 1;
      this.getList();
    },
    handlePager(e) {
      this.page = e;
      this.getList();
    },
    // handleChange(value) {
    //   this.page = 1;
    //   this.getList();
    // },
    // handleClick() {
    //   this.page = 1;
    //   this.getList();
    // },
    async getList() {
      let obj = {
        type: this.type,
        pageNo: this.page,
        pageSize: 10,
      };
      const res = await this.$apis.userServe.myTicketMeetingList(obj);
      this.total = Number(res.data.total);
      this.list = [...res.data.list];
    },
  },
};
</script>

<style lang="scss" scoped>
.zghBox {
  padding-top: 30px;
  width: 1200px;
  .classify {
    display: flex;
    height: 30px;
    justify-content: space-between;
    width: 1200px;

    .right {
      height: 30px;

      .time {
        //background: yellow;
        line-height: 30px;
        margin-right: 10px;
      }

      .searchinput {
        width: 351px;
        //height: 41px;
        border-radius: 10px;
        margin-left: 33px;
      }
    }

    .left {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      cursor: pointer;

      .status {
        margin-right: 3px;
      }

      .statusList {
        margin-left: 10px;
        margin-right: 10px;
      }

      .act {
        margin-left: 10px;
        margin-right: 10px;
        color: #0101f3;
      }
    }
  }
  .list {
    margin-top: 30px;
    .box {
      display: flex;
      // justify-content: space-between;
      margin-bottom: 20px;
      padding: 20px 48px;
      width: 1200px;
      min-height: 160px;
      background: #ffffff;
      box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
      .img {
        margin-right: 25px;
        width: 122px;
        height: 122px;
      }
      .right {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: space-between;
        .yellow {
          margin-right: 10px;
          color: #ff9415;
          vertical-align: middle;
        }
        .red {
          margin-right: 10px;
          color: #ff4f7b;
          vertical-align: middle;
        }
        .blur {
          margin-right: 10px;
          color: #3d95ff;
          vertical-align: middle;
        }
        .title {
          font-size: 18px;
          color: #333333;
          vertical-align: middle;
        }
        .place {
          width: 100px;
          height: 29px;
          line-height: 29px;
          background: #3d95ff;
          border-radius: 10px;
          color: #ffffff;
          text-align: center;
        }
        .checkBtn {
          display: inline-block;
          margin-right: 22px;
          width: 150px;
          height: 63px;
          line-height: 63px;
          border: 1px solid #02157e;
          border-radius: 10px;
          text-align: center;
          font-size: 18px;
          font-weight: bold;
          color: #02157e;
          cursor: pointer;
        }
      }
    }
  }
}
::v-deep .ivu-modal-body {
  padding: 0;
  .tickets-modal {
    padding: 10px 0;
    .modal-title {
      margin: 0 0 30px 45px;
      font-size: 24px;
      color: #333;
    }
    .tickets-item {
      padding-bottom: 16px;
      height: 650px;
      overflow: auto;
    }
    .tickets-scroll {
      margin: 10px 0;
    }
  }
}
</style>
